export default __webpack_public_path__ + "static/media/inventory-kit-variant.d855858f.svg";